module.exports = __webpack_public_path__ + "static/media/Dashboard_09-Members.8cfe31a5.jpg";